import React from 'react'
import { useSelector } from 'react-redux'
const B2C = {
  Success: {
    '10': '#F0FFF0',
    '40': '#8BFF8A',
    '70': '#3CC13B',
  },
  Warning: {
    '10': '#FFFDEB',
    '30': '#FFF491',
    '50': '#FFEB37',
  },
  Danger: {
    '1': '#FFEFEE',
    '2': '#FFC9C9',
    '3': '#FF8788',
    '4': '#FA5252',
    '5': '#DF3130',
  },
  Grey: {
    '9': '#F8F9FB',
    '8': '#F2F3F7',
    '7': '#E9EDF0',
    '6': '#DEE1E6',
    '5': '#CFD4DA',
    '4': '#868D95',
    '3': '#495058',
    '2': '#353A40',
    '1': '#212429',
  },
  Primary: {
    '10': '#EEF6FF',
    '9': '#C8E2FF',
    '8': '#A1CEFF',
    '7': '#7BBAFF',
    '6': '#52A0F5',
    '5': '#3681D3',
    '4': '#2065B1',
    '3': '#034694',
    '2': '#03366D',
    '1': '#00244B',
  },
}

const B2B = {
  Success: {
    '10': '#F0FFF0',
    '40': '#8BFF8A',
    '70': '#3CC13B',
  },
  Warning: {
    '10': '#FFFDEB',
    '30': '#FFF491',
    '50': '#FFEB37',
  },
  Danger: {
    '1': '#FFEFEE',
    '2': '#FFC9C9',
    '3': '#FF8788',
    '4': '#FA5252',
    '5': '#DF3130',
  },
  Grey: {
    '9': '#F8F9FB',
    '8': '#F2F3F7',
    '7': '#E9EDF0',
    '6': '#DEE1E6',
    '5': '#CFD4DA',
    '4': '#868D95',
    '3': '#495058',
    '2': '#353A40',
    '1': '#212429',
  },
  Primary: {
    '10': '#EEF6FF',
    '9': '#EEF6FF',
    '8': '#FFD2B3',
    '7': '#FFB580',
    '6': '#FF974D',
    '5': '#FF7D1F',
    '4': '#FF6A00',
    '3': '#CC5500',
    '2': '#994000',
    '1': '#662B00',
  },
}

const useColors = () => {
  const channelId = useSelector(({ common }) => common.channelId)

  return channelId == 'B2C' ? B2C : B2B
}

export default useColors
